import React, { useEffect, useState } from "react";
import { toReadableTime } from "../../../functions";
import { DateTime } from "luxon";
import { MenuItemsDropDown } from "../../settings/Tags/tagsList";
import MenuDots from '@mui/icons-material/MoreVert';
import { Delete } from "@mui/icons-material";
import { Box } from "@mui/material";
import { LightBox } from "../../../components/molecules/LightBox";
import { FetchImageFromBackoffice } from "../../../utils/request";

export const Comment = ({ avatar, text, userName, timeStamp, onDelete, commentId, userId, loggedInUser, attachments }:
  { userId: string, loggedInUser: string, commentId: string, avatar?: string, text: string, userName: string, timeStamp: string, onDelete: (id: string) => void, attachments?: string[]}) => {
 
    return (
    <Box style={{
      boxShadow: "0 0 12px rgba(51, 50, 50, 0.06)",
      marginBottom: "12px",
      display: "flex",
      justifyContent: "space-between",
    }}>

      {/* <Avatar src={avatar} sx={{ width: 32, height: 32 }} /> */}
      <Box style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px 40px",
      }}>
        <Box style={{
          gap: 6,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "row",
        }}>
          <span style={{
            fontWeight: 500,
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 140,
          }}>{userName}</span>
          <span style={{
            color: "#888",
            fontSize: "14px",
          }}>
            {toReadableTime(DateTime.fromISO(timeStamp), DateTime.now())}
          </span>
        </Box>
        <Box style={{ fontSize: 14 }}>
          {text}
        </Box>
        <Box sx={{display: 'flex',flexDirection: 'column', justifyContent:'flex-start',alignItems:'center', gap:'5px'}}>
          {
            attachments?.map((blobId) => (
              <CommentImage blobId={blobId}/>
            ))
          }
        </Box>
      </Box>
      {userId === loggedInUser && (
        <Box style={{ margin: "20px" }}>
          <MenuItemsDropDown
            menuButton={<MenuDots fontSize="small" />}
            menuItems={[
              {
                label: "Delete",
                icon: <Delete fontSize="small" />,
                onClick: () => onDelete(commentId)
              }
            ]
            }
          />
        </Box>
      )}
    </Box>
  )
}

const CommentImage = ({blobId}) => {
  const [imageURL, setImageURL] = useState<string | undefined>()
  const [open, setOpen] = useState<boolean>()
  
  useEffect(() => {
    FetchImageFromBackoffice<Blob>(`files/comments/files/${blobId}`).then((b) => setImageURL(URL.createObjectURL(b)))
  },[blobId])

  if(!imageURL) return null

  return(
    <>
      <Box sx={{display: 'flex', width:'100%', maxHeight:'300px', overflow:'hidden'}}>
        <img 
          src={imageURL} 
          onClick={() => {
            setOpen(true)
          }} 
          style={{maxWidth:"100%", maxHeight: 300, width: 'auto', height: 'auto', display: 'block'}}/>
      </Box>
      {
        open  && <LightBox image={imageURL} open={open} onClose={() => setOpen(false)}/>
      }
    </>
  )
}

